import { useMutation, useQuery } from "@tanstack/react-query";
import useAxiosInstance from "./axiosInstance.utils";
import { errorFormat } from "./handleError.utils";
import { onSuccessMessage, queryClient } from "./reactQuery.utils";

/**
 * :::::::MUTATIONS:::::::::::
 */

export function useCreateUpazilaMutation(keyData) {
  const { postApi } = useAxiosInstance();
  async function createUpazilaApi(data) {
    try {
      const api = `/upazila`;
      const apiResponse = await postApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["createUpazilaApi", ...keyData],
    mutationFn: (data) => createUpazilaApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("upazilas");
      onSuccessMessage(data, 201);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, createUpazila: mutateAsync };
}

export function useUpdateUpazilaMutation(keyData) {
  const { putApi } = useAxiosInstance();
  async function updateUpazilaApi(data) {
    try {
      const api = `/upazila`;
      const apiResponse = await putApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }
  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["updateUpazilaApi", ...keyData],
    mutationFn: (data) => updateUpazilaApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("upazilas");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, updateUpazila: mutateAsync };
}

export function useDeleteUpazilaMutation(keyData) {
  const { deleteApi } = useAxiosInstance();
  async function deleteUpazilaApi(id) {
    try {
      const api = `/upazila/${id}`;
      const apiResponse = await deleteApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["deleteUpazilaApi", ...keyData],
    mutationFn: (data) => deleteUpazilaApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("upazilas");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, deleteUpazila: mutateAsync };
}

/**
 * :::::::QUERIES:::::::::::
 */
export function useGetAllUpazilaQuery({ query, options = {}, key = "" }) {
  const { getApi } = useAxiosInstance();
  async function getAllUpazilaApi(query) {
    try {
      const api = `/upazilas${query ?? ""}`;
      const apiResponse = await getApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const {
    data,
    isPending: loading,
    ...rest
  } = useQuery({
    queryKey: [`getAllUpazila-${query ?? ""}${key ? "-" + key : ""}`],
    queryFn: () => getAllUpazilaApi(query),
    ...options
  });
  const newData = data?.data?.data ?? {};
  const parents = data?.data?.parents ?? [];
  return { data: newData, parents, loading, ...rest };
}
